import { combineReducers } from 'redux';
import getFilterActive from './get_filter_active';
import offline from './offline';

export default combineReducers({
  filterAct: getFilterActive,
  offline: offline
});